export default "__VITE_ASSET__DCpHaYH$__"